/**
 * Created by minimus on 26.04.2015.
 */

(function($){
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  $(document).ready(function() {
    const dialog = $('#info-dialog');
    const dlgBody = $('#info-body');
    let dlg;
    const dlgOptions = {
      width: 830,
      allowDraggable: true,
      enableModal: true,
      showOnInit: false,
      closeIconTooltip: options.close
    };
    let lis;
    const dm = ej.DataManager({
      url: `${ajaxurl}?action=load_error_log&sam_pro_nonce=${options.samProNonce}`,
      removeUrl: `${ajaxurl}?action=remove_error&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });

    dlgBody.html(() => {
      return `<div style="margin: 10px 10px 10px 0;">
        <div style="margin: 10px 0;">
        <aside id="info-img" style="float: left; width: 80px; font-size: 50px;"></aside>
        <div style="padding-left: 80px">
        <p><strong>${options.date}</strong>: <span id="el-date"></span></p>
        <p><strong>${options.table}</strong>: <span id="el-table"></span></p>
        <p><strong>${options.etype[0]}</strong>: <span id="el-type"></span></p>
        <p><strong>${options.msg}</strong>:<br><span id="el-msg"></span></p>
        <p><strong>${options.sql}</strong>:</p>
        <textarea id="el-sql" style="width: 100%; height: 270px;" readonly></textarea>
        </div></div></div>`;
    });
    dlg = dialog.ejDialog(dlgOptions).data('ejDialog');
    $('#close-dialog').on('click', function() {
      dlg.close();
    });

    const grid = $('#grid').ejGrid({
      dataSource: dm,
      locale: ejLocale,
      allowTextWrap: true,
      allowPaging: true,
      allowSorting: true,
      pageSettings: {pageSize: options.itemsPerPage},
      allowSelection: true,
      selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
      editSettings: {allowDeleting: true},
      toolbarSettings: {
        showToolbar: true,
        toolbarItems: [
          ej.Grid.ToolBarItems.Delete
        ],
        customToolbarItems: [
          {templateID: '#viewMode'},
          'Refresh',
          {templateID: '#MoreInfo'},
          {templateID: "#ErrorSolved"},
          {templateID: "#ClearErrors"}
        ]
      },
      actionComplete: function(args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        li = $('#grid_delete');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_MoreInfo');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_ErrorSolved');
        $tb.ejToolbar('disableItem', li);
      },
      recordClick: function(args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        const recs = this.getSelectedRecords();
        const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
        li = $('#grid_delete');
        $tb.ejToolbar(action, li);
        li = $('#grid_MoreInfo');
        $tb.ejToolbar(action, li);
        li = $('#grid_ErrorSolved');
        $tb.ejToolbar(action, li);
      },
      toolbarClick: function (sender, args) {
        const tbarObj = $(sender.target);
        const rec = this.getSelectedRecords();
        let eSolved;
        if (tbarObj.hasClass("Refresh"))
          this.refreshContent();
        else if(tbarObj.hasClass("more-info")) {
          if(rec.length > 0) {
            const eType = parseInt(rec[0].etype, 10);
            eSolved = parseInt(rec[0].solved, 10);
            $('#info-img').html(function() {
              return ((eType === 1) ? "<i class='icon-ok'></i>" :
                ((eSolved === 1) ? "<i class='icon-shield'></i>" : "<i class='icon-attention'></i>"));
            });
            $('#el-date').text(rec[0].edate);
            $('#el-table').text(rec[0].tname);
            $('#el-type').text(options.alts[eType]);
            $('#el-msg').text(rec[0].emsg);
            $('#el-sql').html(rec[0].esql);

            dlg.open();
          }
        }
        else if(tbarObj.hasClass('error-solved')) {
          if(rec.length > 0) {
            eSolved = parseInt(rec[0].solved, 10);
            if(eSolved === 0) {
              //$.post(options.samProAjax + 'sam-pro-ajax-admin.php', {
              $.post(ajaxurl, {
                action: 'solve_error',
                eid: parseInt(rec[0].eid, 10),
                sam_pro_nonce: options.samProNonce
              }).done((data) => {
                if(data.success) grid.refreshContent();
              });
            }
          }
        }
        else if(tbarObj.hasClass('clear-errors')) {
          $.post(ajaxurl, {
            action: 'clear_error_log',
            sam_pro_nonce: options.samProNonce
          }).done((data) => {
            if(data.success) grid.refreshContent();
          });
        }
        else if(tbarObj.hasClass('Edit')) {
          if(rec.length > 0) {
            const item = rec[0].aid;
            document.location = options.editorUrl + item;
          }
        }
        else if (tbarObj.hasClass('place-to-trash') || tbarObj.hasClass('place-from-trash')) {
          const toFrom = ((tbarObj.hasClass('place-to-trash')) ? 1 : 0);
          if (rec.length > 0) {
            const trash = parseInt(rec[0].trash, 10);

            aid = parseInt(rec[0].aid, 10);
            if (trash !== toFrom) {
              $.post(ajaxurl, {
                action: 'trash_ad',
                aid: aid,
                trash: toFrom,
                sam_pro_nonce: options.samProNonce
              }).done((data) => {
                const sel = parseInt(ddList.getSelectedValue(), 10);
                if (sel === 0) grid._disabledToolItems.push(lis[8]);
                else if (sel === 1) grid._disabledToolItems.push(lis[7]);
                grid.refreshContent();
              });
            }
          }
        }
        else if(tbarObj.hasClass('ad-moderate') || tbarObj.hasClass('ad-unmoderate')) {
          const mod = ((tbarObj.hasClass('ad-moderate')) ? 1 : 0);
          if(rec.length > 0) {
            const moderated = parseInt(rec[0].moderated, 10);

            aid = parseInt(rec[0].aid, 10);
            if(moderated !== mod) {
              $.post(ajaxurl, {
                action: 'moderate_ad',
                aid: aid,
                mod: mod,
                sam_pro_nonce: options.samProNonce
              }).done(() => {
                grid.refreshContent();
              });
            }
          }
        }
      },
      create: function (args) {
        const $toolbar = $('#grid_toolbarItems');
        lis = $toolbar.find("li");
        $('.more-info').parent('li').attr('title', options.moreInfo);
        $('.error-solved').parent('li').attr('title', options.setSolved);
        $('.clear-errors').parent('li').attr('title', options.clearLog);
        $('.ad-unmoderate').parent('li').attr('title', options.cancelApproval);
        $('li[title="viewMode"]').attr('title', options.viewMode);
        $('.Refresh').parent('li').attr('title', options.refresh);
      },
      columns: [
        {field: 'eid', headerText: options.id, isPrimaryKey: true, textAlign: ej.TextAlign.Right, allowSorting: true, allowEditing: false, width: 100},
        {field: 'stype', headerText: options.etype[1], textAlign: ej.TextAlign.Center, allowSorting: true, allowEditing: false, width: 100},
        {field: 'edate', headerText: options.date, allowSorting: true, allowEditing: false, width: 150},
        {field: 'tname', headerText: options.table, allowSorting: true, allowEditing: false, width: 170},
        {field: 'emsg', headerText: options.msg, allowSorting: true, allowEditing: false},
        {field: 'etype', headerText: options.status, allowSorting: false, allowEditing: false, visible: false},
        {field: 'esql', headerText: options.sql, allowSorting: false, allowEditing: false, visible: false},
        {field: 'solved', headerText: options.status, allowEditing: false, visible: false}
      ]
    }).data('ejGrid');

    const ddList = $('#view-mode').ejDropDownList({
      selectedItemIndex: 0,
      change: function (args) {
        const sel = parseInt(this.getSelectedValue(), 10);
        if (sel !== 10) {
          $('#grid').ejGrid('model.query', new ej.Query().where('etype', ej.FilterOperators.equal, sel, 10));
        }
        else {
          $('#grid').ejGrid('model.query', new ej.Query());
        }
        grid.refreshContent(true);
      }
    }).data('ejDropDownList');
  });
})(jQuery);